import {
    RESET_PASSWORD,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILURE,
} from "../../Actions/types";

const initialState = {
  loader: false,
  error: false,
  data: null,
};
function resetPasswordReducer(state = initialState, action) {
  switch (action.type) {
    case RESET_PASSWORD:
      return { ...state, data: action.payload, loader: true };

    case RESET_PASSWORD_SUCCESS:
      return { ...state, data: action.payload, loader: false };

    case RESET_PASSWORD_FAILURE:
      return { ...state, error: true, loader: false };

    default:
      return state;
  }
}

export default resetPasswordReducer;
